import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { CricketInningsData, CricketScore, EventScoreboard } from '@frontend/sports/betting-offer/feature/model';

@Component({
    selector: 'ms-cricket-scoreboard',
    templateUrl: 'cricket-scoreboard.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf],
})
export class CricketScoreboardComponent {
    @Input() scoreboard: EventScoreboard;
    @HostBinding('class') className = 'cricket';

    get score(): CricketScore {
        return this.scoreboard.getScore<CricketScore>() as CricketScore;
    }

    get innings(): CricketInningsData {
        return this.score.superOver || this.score.secondInnings || this.score.firstInnings!;
    }
}
